import CourtLineDivider from "./CourtLineDivider";

export default function Header({ title, tech = "", description = "description", link = "", h2 = false, verbose = "" }) {
    return (
        <div className = "sporty-nerd-header" style = {{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: !h2 ? "40px 0px" : "16px 0px",
            width: "100%"
        }}>
            
            {/* <div style ={ { width : "48px", height : "40px", display : "flex", alignItems : "center", overflow : "hidden" }}>
                <CourtLineDivider/>
            </div> */}

            { !h2 && <CourtLineDivider/> }

            {h2 ? <h3>{ title }</h3> : <h1>{ title }</h1>}
            <div style = { { opacity : 0.80, display : "flex", flexDirection : "row", alignItems : "center", justifyContent : "center", gap : "8px" } }>
                { tech && <h4>{ tech }</h4> }
                { tech && <span>🤝</span> }
                <h4 style = { { fontFamily : "var(--font-Source)", fontStyle : "italic" } }>{ description } </h4>
            </div>
            <p className = "caption" style = { { whiteSpace : "pre-wrap" } }>{ verbose }</p>
        </div>
    );
};